import { render, staticRenderFns } from "./KbDocumentManage.vue?vue&type=template&id=4345e969&scoped=true&"
import script from "./KbDocumentManage.vue?vue&type=script&lang=js&"
export * from "./KbDocumentManage.vue?vue&type=script&lang=js&"
import style0 from "./KbDocumentManage.vue?vue&type=style&index=0&id=4345e969&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345e969",
  null
  
)

export default component.exports